import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar'

import { AiOutlineHome, AiOutlineLogout } from 'react-icons/ai'
import { MdDashboard, MdSettings } from 'react-icons/md'
import { RiAuctionLine, RiHandCoinLine } from 'react-icons/ri'
import Connector from '../../utils/connector'
import { path } from '../../utils/const'
import { storage } from '../../utils/firebase'
import { images } from '../../theme'

import './styles.css'
import { Profile } from './SideBar.css'
import styler from '../../theme/styler'

const styles = styler({
  name: {
    color: 'white',
    padding: '20px',
    fontSize: '20px',
    marginTop: 15,
  },
  img: {
    width: 50,
    height: 50,
    borderRadius: 30,
    marginRight: 10,
    marginLeft: 15,
    marginBottom: 10,
  },
})

class SideBar extends Component {
  state = {
    userName: null,
    userImage: images.profile,
    userType: null,
  }

  componentDidMount() {
    // set default image
    const { state } = this.props
    storage
      .child(state.app.me.photoURL)
      .getDownloadURL()
      .then(url => {
        this.setState({
          userImage: url,
          userName: state.app.me.displayName,
          userType: state.app.user.userType,
        })
      })
  }

  render() {
    const { userImage, userName, userType } = this.state
    const { actions, onClick } = this.props

    // TODO: Refactor to <Link to="">
    return (
      <ProSidebar>
        <SidebarHeader>
          <Profile>
            <div
              style={{
                padding: '24px',
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: 24,
                letterSpacing: '1px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <img src={userImage} className={styles.img} alt="profile" />
              {userName && <div>{userName}</div>}
              {userType && (
                <div
                  style={{
                    fontWeight: 'normal',
                    fontSize: 16,
                  }}
                >
                  {userType}
                </div>
              )}
            </div>
          </Profile>
        </SidebarHeader>
        <SidebarContent>
          <Menu iconShape="circle">
            <MenuItem icon={<AiOutlineHome />} onClick={onClick}>
              Home
              <Link to={path.home} />
            </MenuItem>
            <MenuItem icon={<MdDashboard />} onClick={onClick}>
              Overview Board
              <Link to={path.dashboard} />
            </MenuItem>

            {userType === 'client' && (
              <MenuItem icon={<RiAuctionLine />} onClick={onClick}>
                Generate Auction
                <Link to={path.createAuction} />
              </MenuItem>
            )}

            {userType === 'business' && (
              <MenuItem icon={<RiHandCoinLine />} onClick={onClick}>
                Create Offer
                <Link to={path.searchAuction} />
              </MenuItem>
            )}

            {/* <MenuItem icon={<AiOutlineHeart />}>Rating</MenuItem> */}
            <MenuItem icon={<MdSettings />} onClick={onClick}>
              Profile Settings
            </MenuItem>
          </Menu>
        </SidebarContent>
        <SidebarFooter>
          <Menu iconShape="circle">
            <MenuItem icon={<AiOutlineLogout />} onClick={actions.app.logout}>
              Logout
            </MenuItem>
          </Menu>
        </SidebarFooter>
      </ProSidebar>
    )
  }
}

const ConnectedSidebar = props => (
  <Connector>
    {({ actions, state }) => (
      <SideBar actions={actions} state={state} {...props} />
    )}
  </Connector>
)

// SideBar.propTypes = {
// }
// SideBar.defaultProps = {}

export default ConnectedSidebar
